"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterNumberCell = void 0;
const number_field_1 = require("../../../components/number-field/number-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
exports.FilterNumberCell = filter_interval_cell_factory_1.filterIntervalCellFactory(number_field_1.NumberField);
//# sourceMappingURL=filter-number-cell.js.map